<div class="activity-container">
  <!-- Header Principal -->
  <div class="activity-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-clock-rotate-left"></i>
        <div class="header-text">
          <h1>Bitácora del arrendamiento</h1>
          <p class="header-subtitle">Historial de cambios (auditoría) y comentarios del arrendamiento</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Historial de cambios (auditoría) — registro automático e inmutable, en línea de tiempo -->
  <div class="info-card wide-card">
    <div class="card-header">
      <i class="fa-solid fa-clock-rotate-left text-purple-600"></i>
      <h3>Historial de cambios</h3>
      <div class="header-tags">
        <p-tag [value]="auditEntries.length + ' evento(s)'" severity="info"></p-tag>
      </div>
    </div>
    <div class="card-content">
      <p-timeline *ngIf="auditEntries.length > 0" [value]="auditEntries" align="left" styleClass="audit-timeline">
        <ng-template pTemplate="marker" let-entry>
          <span class="audit-marker" [ngClass]="markerTone(entry)"><i class="fa-solid" [ngClass]="markerIcon(entry)"></i></span>
        </ng-template>
        <ng-template pTemplate="content" let-entry>
          <div class="audit-entry">
            <div class="audit-entry-title">{{ actionLabel(entry.action) }}</div>
            <!-- Movimiento de un pago: monto, letras, clave de rastreo y fecha del depósito -->
            <div class="audit-change audit-payment" *ngIf="isPaymentEntry(entry); else cambioDeValor">
              <ng-container *ngIf="isDateChangeEntry(entry); else correccionOMovimiento">
                <span class="val-prev">{{ formatValue(entry.metadata?.previousDate ?? entry.previousValue) }}</span>
                <i class="fa-solid fa-arrow-right-long"></i>
                <span class="val-new">{{ formatValue(entry.metadata?.newDate ?? entry.newValue) }}</span>
                <small class="audit-change-hint">fecha del depósito</small>
              </ng-container>
              <ng-template #correccionOMovimiento>
                <ng-container *ngIf="isAmountCorrectionEntry(entry); else movimiento">
                  <span class="val-prev">{{ formatMoney(entry.metadata?.previousAmount) }}</span>
                  <i class="fa-solid fa-arrow-right-long"></i>
                  <span class="val-new">{{ formatMoney(entry.metadata?.newAmount) }}</span>
                  <small class="audit-change-hint">monto del depósito</small>
                </ng-container>
              </ng-template>
              <ng-template #movimiento>
                <span class="audit-amount" [ngClass]="markerTone(entry)">{{ formatMoney(entry.metadata?.amount) }}</span>
                <span class="audit-periods" *ngIf="formatPeriods(entry.metadata?.periods) as letras">{{ letras }}</span>
                <small class="audit-change-hint" *ngIf="applicationTypeLabel(entry.metadata?.applicationType) as tipo">{{ tipo }}</small>
              </ng-template>
            </div>
            <div class="audit-meta" *ngIf="isPaymentEntry(entry) && (entry.metadata?.trackingKey || entry.metadata?.paymentDate)">
              <span *ngIf="entry.metadata?.trackingKey">Referencia {{ entry.metadata.trackingKey }}</span>
              <span *ngIf="entry.metadata?.trackingKey && entry.metadata?.paymentDate && !isDateChangeEntry(entry)"> · </span>
              <span *ngIf="entry.metadata?.paymentDate && !isDateChangeEntry(entry)"
                >depósito del {{ formatValue(entry.metadata.paymentDate) }}</span
              >
            </div>
            <ng-template #cambioDeValor>
              <div class="audit-change">
                <ng-container *ngIf="isAmountsEntry(entry); else plainChange">
                  <span class="val-prev">{{ formatMoney(entry.previousValue) }}</span>
                  <i class="fa-solid fa-arrow-right-long"></i>
                  <span class="val-new">{{ formatMoney(entry.newValue) }}</span>
                  <small class="audit-change-hint">valor de cartera</small>
                </ng-container>
                <ng-template #plainChange>
                  <ng-container *ngIf="isRateEntry(entry); else valorLlano">
                    <span class="val-prev">{{ formatRate(entry.previousValue) }}</span>
                    <i class="fa-solid fa-arrow-right-long"></i>
                    <span class="val-new">{{ formatRate(entry.newValue) }}</span>
                    <small class="audit-change-hint">tasa moratoria mensual</small>
                  </ng-container>
                  <ng-template #valorLlano>
                    <ng-container *ngIf="isStatusEntry(entry); else valorSuelto">
                      <p-tag [value]="formatValue(entry.previousValue)" [severity]="statusSeverity(entry.previousValue)"></p-tag>
                      <i class="fa-solid fa-arrow-right-long"></i>
                      <p-tag [value]="formatValue(entry.newValue)" [severity]="statusSeverity(entry.newValue)"></p-tag>
                      <small class="audit-change-hint" *ngIf="valueHint(entry) as hint">{{ hint }}</small>
                    </ng-container>
                  </ng-template>
                  <ng-template #valorSuelto>
                    <span class="val-prev">{{ formatValue(entry.previousValue) }}</span>
                    <i class="fa-solid fa-arrow-right-long"></i>
                    <span class="val-new">{{ formatValue(entry.newValue) }}</span>
                    <small class="audit-change-hint" *ngIf="valueHint(entry) as hint">{{ hint }}</small>
                  </ng-template>
                </ng-template>
              </div>
            </ng-template>
            <div class="audit-meta" *ngIf="entry.metadata?.periodsAffected">
              {{ periodsSummary(entry)
              }}<span *ngIf="entry.metadata?.periodsAffectedPaid">
                · {{ entry.metadata.periodsAffectedPaid }} ya pagado(s)/atrasado(s)</span
              >
            </div>

            <!-- Deshacer: la entrada original nunca se borra; la reversión queda como una entrada más -->
            <div class="audit-revert" *ngIf="isAmountsEntry(entry)">
              <ng-container *ngIf="canRevert(entry); else yaRevertida">
                <ng-container *appIfHasPermission="['leases', 'edit-amounts']">
                  <button
                    pButton
                    type="button"
                    label="Deshacer"
                    icon="pi pi-undo"
                    class="p-button-text p-button-sm p-button-danger"
                    [loading]="reverting === entry._id"
                    [disabled]="!!reverting"
                    (click)="confirmRevert(entry)"
                  ></button>
                </ng-container>
              </ng-container>
              <ng-template #yaRevertida>
                <span class="audit-reverted" *ngIf="revertedBy(entry) as rev">
                  <i class="pi pi-undo"></i> Deshecha el {{ rev.date | date: 'dd/MM/yyyy HH:mm' }}
                </span>
              </ng-template>
            </div>

            <!-- Detalle por letra: una edición en cascada deja UNA fila legible, no sesenta -->
            <ng-container *ngIf="isAmountsEntry(entry) && periodDiffs(entry).length">
              <button type="button" class="audit-detail-toggle" (click)="toggleDetail(entry)">
                <i class="fa-solid" [ngClass]="isExpanded(entry) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                Ver detalle de {{ periodDiffs(entry).length }} letra(s)
              </button>
              <div class="audit-detail" *ngIf="isExpanded(entry)">
                <table class="audit-diff-table">
                  <thead>
                    <tr>
                      <th class="is-left">Letra</th>
                      <th *ngFor="let c of diffColumns(entry)">{{ c.label }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let d of periodDiffs(entry)">
                      <td class="is-left audit-detail-period">{{ d.period }}</td>
                      <td *ngFor="let c of diffColumns(entry)">
                        <ng-container *ngIf="diffCell(d, c.key) as cell; else sinCambio">
                          <small class="audit-detail-prev">{{
                            c.money ? (cell.antes | currency: 'MXN' : 'symbol' : '1.2-2') : cell.antes
                          }}</small>
                          <span class="audit-detail-new">{{
                            c.money ? (cell.despues | currency: 'MXN' : 'symbol' : '1.2-2') : cell.despues
                          }}</span>
                        </ng-container>
                        <ng-template #sinCambio><span class="audit-detail-none">—</span></ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
            <div class="audit-reason" *ngIf="entry.reason"><span class="reason-label">Motivo:</span> {{ entry.reason }}</div>
            <div class="audit-footer">
              <span class="audit-author"><i class="fa-solid fa-user"></i> {{ authorName(entry.user) }}</span>
              <span class="audit-date">{{ entry.date | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        </ng-template>
      </p-timeline>

      <div class="no-content" *ngIf="auditEntries.length === 0">
        <i class="pi pi-history"></i>
        <p>No hay cambios registrados en la auditoría de este arrendamiento.</p>
      </div>
    </div>
  </div>

  <!-- Comentarios — notas humanas (alta/baja se gestionan aquí) -->
  <div class="info-card wide-card">
    <div class="card-header">
      <i class="fa-solid fa-comments text-indigo-600"></i>
      <h3>Comentarios</h3>
      <div class="header-tags">
        <button
          pButton
          type="button"
          class="p-button-sm p-button-outlined"
          icon="pi pi-plus"
          label="Agregar Comentario"
          (click)="openAddComment()"
        ></button>
      </div>
    </div>
    <div class="card-content">
      <div class="comments-container" *ngIf="commentsService.comments$ | async as allComments">
        <ng-container *ngIf="allComments.length > 0; else noComments">
          <div class="comment-item" *ngFor="let comment of allComments">
            <div class="comment-header">
              <div class="author-info">
                <strong>{{ comment.author.names }} {{ comment.author.lastNames }}</strong>
                <span class="comment-date">{{ comment.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <div class="comment-actions">
                <button
                  pButton
                  type="button"
                  class="p-button-sm p-button-text p-button-danger delete-comment-btn"
                  icon="pi pi-times"
                  pTooltip="Eliminar comentario"
                  tooltipPosition="left"
                  (click)="confirmDeleteComment(comment._id)"
                  [loading]="(commentsService.loading$ | async) ?? false"
                ></button>
              </div>
            </div>
            <div class="comment-content">{{ comment.content }}</div>
          </div>
        </ng-container>

        <ng-template #noComments>
          <div class="no-content">
            <i class="pi pi-comment"></i>
            <p>Este arrendamiento no tiene comentarios registrados.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Dialog para agregar comentario -->
<p-dialog
  [(visible)]="addCommentDialog"
  [modal]="true"
  styleClass="billing-comment-dialog"
  [style]="{ width: '500px', maxWidth: '90vw' }"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-comment"></i>
      <span>Agregar Comentario</span>
    </div>
  </ng-template>

  <div class="p-fluid">
    <div class="field">
      <label for="commentInput"><i class="pi pi-pencil"></i> Comentario:</label>
      <textarea
        id="commentInput"
        pInputTextarea
        [(ngModel)]="newCommentValue"
        rows="4"
        placeholder="Escribe tu comentario aquí..."
        [disabled]="(commentsService.loading$ | async) ?? false"
        maxlength="500"
        class="w-full"
      >
      </textarea>
      <small class="text-muted">{{ newCommentValue.length || 0 }}/500 caracteres</small>
      <small class="p-error" *ngIf="commentError">{{ commentError }}</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="cancelAddComment()"
      [disabled]="(commentsService.loading$ | async) ?? false"
    ></button>
    <button
      pButton
      type="button"
      label="Agregar"
      icon="pi pi-check"
      class="p-button-primary"
      (click)="addComment()"
      [loading]="(commentsService.loading$ | async) ?? false"
      [disabled]="!newCommentValue.trim() || ((commentsService.loading$ | async) ?? false)"
    ></button>
  </ng-template>
</p-dialog>

<!-- Deshacer una edición de saldos: vista previa con el cambio de estado y cada advertencia por confirmar -->
<p-dialog
  [visible]="showRevertDialog"
  (visibleChange)="!$event && closeRevert()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(560px, 95vw)' }"
  header="Deshacer esta edición"
  appendTo="body"
  styleClass="revert-dialog"
>
  <p class="revert-message">{{ revertMessage }}</p>

  <div class="revert-loading" *ngIf="revertLoading" aria-busy="true">
    <i class="pi pi-spin pi-spinner"></i> Calculando cómo quedaría el arrendamiento…
  </div>
  <div class="revert-error" *ngIf="revertPreviewError" role="alert">
    <i class="pi pi-exclamation-triangle"></i> {{ revertPreviewError }}
  </div>

  <ng-container *ngIf="revertPreview">
    <app-lease-status-change
      [before]="revertPreview.leaseOutcome?.before"
      [after]="revertPreview.leaseOutcome?.after"
    ></app-lease-status-change>
    <div class="revert-warnings" *ngIf="revertPreview.warnings?.length">
      <div class="revert-warn" *ngFor="let w of revertPreview.warnings" [class.is-blocking]="w.blocking">
        <div class="revert-warn-head">
          <i class="pi" [ngClass]="w.blocking ? 'pi-exclamation-circle' : 'pi-info-circle'"></i>
          <!-- Título y mensaje en bloques propios: nunca se leen pegados, aunque falte el estilo -->
          <div class="revert-warn-text">
            <div class="revert-warn-title" *ngIf="warningLabels[w.code] as titulo">{{ titulo }}</div>
            <div class="revert-warn-message">{{ w.message }}</div>
          </div>
        </div>
        <div class="field-checkbox" *ngIf="w.blocking">
          <p-checkbox [(ngModel)]="revertConfirmations[w.code]" [binary]="true" [inputId]="'revert-warn-' + w.code"></p-checkbox>
          <label [for]="'revert-warn-' + w.code">Entiendo y confirmo</label>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text p-button-secondary"
      (click)="closeRevert()"
      [disabled]="!!reverting"
    ></button>
    <button
      pButton
      type="button"
      label="Sí, deshacer"
      icon="pi pi-undo"
      class="p-button-danger"
      (click)="applyRevert()"
      [disabled]="!canConfirmRevert"
      [loading]="!!reverting"
    ></button>
  </ng-template>
</p-dialog>

<!-- Confirmación de eliminación + toast -->
<p-confirmDialog
  header="Confirmar eliminación"
  icon="pi pi-exclamation-triangle"
  acceptLabel="Eliminar"
  rejectLabel="Cancelar"
  acceptButtonStyleClass="p-button-danger"
></p-confirmDialog>
<p-toast position="top-right"></p-toast>
